import { IEnvironment } from './ienvironment';

export const environment: IEnvironment = {
  production: false,
};